module.exports = __webpack_public_path__ + "img/SOM.dde01623.svg";